import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';

// Components

import NavBar from '../../components/common/navBar/NavBar';

// ActionCreators

import { fetchNavBarData } from '../../actions/delegation/delegationActionCreators';

// Utils

//import { appendClassNames } from '../../utils/miscellaneous/appendClassNames';

// Constants

import { configs } from '../../constants/configs/configs';
import { USER_GROUPS } from '../../constants/roles/userRoleTypes';


const NavBarContainer = props => {

    const ALL_ROLES = 'ALL_ROLES';
    const { endpoints } = configs;

    const {
        arrayOfUserRoles = ALL_ROLES,
        delegation: {
            navBar = []
        },
        fetchNavBarData,
        houseIcon,
        navBarClass,
        roleGroup = ALL_ROLES
    } = props;

    const userRoleMatches = useMemo(
        () => roleGroup === ALL_ROLES || arrayOfUserRoles.includes(roleGroup) || roleGroup == USER_GROUPS.AGENCY_GROUP,
        [ roleGroup ]
    );

    useEffect(() => {
        if (userRoleMatches) {
            fetchNavBarData(endpoints.NAV_BAR);
        }
    }, [ ]);

    return (
        userRoleMatches && navBar.length > 0 ?
            <div className={ navBarClass }>
                <NavBar menu={ navBar } houseIcon={ houseIcon }/>
            </div>:
            null
    );
};

const mapStateToProps = state => ({
    delegation: state.delegation
});

export default connect(mapStateToProps, { fetchNavBarData })(NavBarContainer);